const checkArrayInArray = ({ mainArr, Arr }) => mainArr.some(el => Arr.indexOf(el) !== -1);

export default checkArrayInArray;
